import { GramPostProps } from "../../../Components/TheGramApp/TheGramAppInterfaces";

import pic1 from "./InfluencerTheGramAssets/TheGram_Feed_Post_1.png";
import pic2 from "./InfluencerTheGramAssets/TheGram_Feed_Post_2.png";
import pic3 from "./InfluencerPictures/JoshPhone_Photos_3.jpg";
import pic4 from "./InfluencerTheGramAssets/NewPic-05.webp";
import dp1 from "./InfluencerTheGramAssets/TheGram_Feed_ProfilePic_1.jpg";
import dp2 from "./InfluencerTheGramAssets/TheGram_Feed_ProfilePic_2.jpg";
import dp3 from "./InfluencerTheGramAssets/TheGram_Profile_Rosa.jpg";
import dp4 from "./InfluencerTheGramAssets/ProfilePic.webp";

export const InfluencerTheGramContent: GramPostProps[] = [
  {
    Profile: { name: "ARJ_1992", image: dp1 },
    Date: "Fri 24 May 2024, 7:43 PM",
    Image: pic1,
    Likes: "RosaGutierrez and others",
    Caption: "NYC 🇺🇸",
    Location: "Brooklyn, New York",
  },
  {
    Profile: { name: "adam_tp", image: dp2 },
    Date: "Fri 24 May 2024, 9:29 PM",
    Image: pic2,
    Likes: "NWilliams and others",
    Caption:
      "Water bottle empty, workout done and now little bit of stretching 🧘🏼‍♂️ What do you train today?, #workout #recharge",
    Location: "Boston, Massachusetts",
  },
  {
    Profile: { name: "TheRealPeteGraziano", image: dp4 },
    Date: "Sun 26 May 2024, 10:07 PM",
    Image: pic4,
    Likes: "RosaGutierrez and others",
    Caption:
      "Done partying for the weekend. Now for a peaceful evening of meditation in my hotel room.",
    Location: "Bali, Indonesia",
  },
  {
    Profile: { name: "RosaGutierrez", image: dp3 },
    Date: "Sun 26 May 2024, 11:32 AM",
    Image: pic3,
    Likes: "TheRealPeteGraziano and others",
    Caption:
      "Touched down in Bali! 🌴 Ready to party the weekend away with my favs🍹 @JoshMendoza @TheRealPeteGraziano @TK_rah @Tjohnson @gabihogar @rachdavis",
    Location: "Bali, Indonesia",
  },
  // Add more dummy data objects as needed
];
